"use client";

import styles from "./SegmentedControl.module.css";

export default function SegmentedControl({
  options,
  value,
  onChange,
  fitContent = false,
  size = "sm",
  className = "",
  "aria-label": ariaLabel,
}) {
  const sizeClass = {
    sm: "",
    md: styles.md,
    lg: styles.lg,
  }[size] || "";

  const containerClasses = [
    styles.container,
    fitContent ? styles.fitContent : "",
    sizeClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses} role="tablist" aria-label={ariaLabel}>
      {options.map((option) => {
        const isActive = option.value === value;
        const segmentSizeClass = {
          sm: "",
          md: styles.segmentMd,
          lg: styles.segmentLarge,
        }[size] || "";
        const classes = [
          styles.segment,
          segmentSizeClass,
          isActive ? styles.segmentActive : "",
        ]
          .filter(Boolean)
          .join(" ");
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={option.disabled}
            className={classes}
            onClick={() => {
              if (!option.disabled) onChange?.(option.value);
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
